/**
 * The JSON inside a ``` fence, or the text untouched when there is none.
 *
 * Models wrap JSON in ```json blocks against an explicit instruction often
 * enough that refusing it would mark answers malformed over a decoration, so
 * the readers of the scribe and of the analyst forgive it (`readScribeReport`,
 * `readAnalystAnswer`). In `shared` since #152 because a SCREEN reads those
 * answers again too - the parcours of Sessions says why an attempt of the
 * analyst failed - and a second spelling of what a fence is would make it read
 * « pas du JSON » on an answer the server had parsed past its fence.
 */
export function unfenced(raw: string): string {
  const trimmed = raw.trim();
  const fence = /^```(?:json)?\s*\n?([\s\S]*?)\n?```$/.exec(trimmed);
  return (fence?.[1] ?? trimmed).trim();
}
